// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"466":"3d724966","595":"6b740c09"}[chunkId] + ".chunk.js";
};